import React from 'react'
import get from 'lodash.get'
import Slider from 'react-slick'
import CardPlan from 'components/molecules/CardPlan'
import { userCheckMobileScreen } from 'helpers/tools'

// Styles
import './PlanList.scss'
import 'slick-carousel/slick/slick.css'

function PlanList(props) {
  const color = get(props, 'color')
  const items = get(props, 'items')

  const isMobile = userCheckMobileScreen()
  const setting = {
    dots: true,
    dotsClass: `slick-dots ${color || 'primary'}`,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <Slider className="plans-list plans-slider" {...setting}>
      {Array.isArray(items) &&
        items.map((plan, index) => (
          <CardPlan
            alt={get(plan, 'media.entity.images.alt')}
            descriptions={get(plan, 'simple_descriptions')}
            key={index}
            title={get(plan, 'title')}
            stamp={{
              image: get(plan, 'tag.entity.images.medium.url'),
              alt: get(plan, 'tag.entity.images.alt'),
            }}
            image={isMobile ? get(plan, 'media.entity.images.medium.url') : get(plan, 'media.entity.images.large.url')}
            footer={{
              cta: `Conheça ${get(plan, 'title')}`,
              url: `${get(plan, 'link.path')}`,
            }}
          />
        ))}
    </Slider>
  )
}

export default PlanList
